module.exports = __webpack_public_path__ + "img/ch16_11_报平安电话.dac32c98.jpg";